import { createAction, props } from '@ngrx/store';

export const loadExperiments = createAction(
  '[Optly] Load Experiments',
  props<{ payload: string[] }>()
);

export type OptlyActions = typeof loadExperiments;
